import "../modules/mobileFilters";

import api from "../api/index";
import { ready, on } from "../utils/listeners";
import { parse, serialise } from "../utils/form";
import applyFilters from "../modules/applyFilters";
import destroyVueApps from "../utils/destroyVueApps";

function sorterResize(width) {
  const root = document.documentElement;
  root.style.setProperty("--dynamic-size", `${width}px`);
}

function initSorterResize() {
  const helperElement = document.querySelector(".helper-element");
  if (helperElement) {
    if (!document.querySelector(".sidebar-checkbox")) {
      helperElement.innerHTML = document.querySelector(
        ".js-sorter option:checked"
      ).innerText;
      sorterResize(helperElement.offsetWidth);
    }
  }
}

const reflowActiveFilters = () => {
  const activeFiltersContainer = document.querySelector(".active-filters");
  const showMoreButton = document.querySelector(".js-show-more-button");
  let activeFilters = document.querySelectorAll(".js-active-filter");
  let hiddenActiveFilterCount = 0;

  const isMobile = window.innerWidth <= 992;
  const maxHeight = isMobile ? 120 : 60;

  if (activeFiltersContainer) {
    if (document.body.classList.contains("js-filters-expanded")) {
      document.body.classList.remove("js-filters-expanded");
    }
    while (
      // The container only requires collapsing if its scrollHeight is greater than maxHeight and if a user hasn't expanded it themselves
      activeFiltersContainer.scrollHeight > maxHeight &&
      !document.body.classList.contains("js-filters-expanded")
    ) {
      // Whilst the above is true reveal the show more button and identify the last active filter
      showMoreButton.classList.remove("hidden");
      const lastActiveFilter = activeFilters[activeFilters.length - 1];

      // Keep adding hidden to the last active filter until the active filter container returns to less than maxHeight of scroll height
      if (lastActiveFilter) {
        lastActiveFilter.classList.add("hidden");
        hiddenActiveFilterCount += 1;
      } else {
        break;
      }

      showMoreButton.innerText = `Show +${hiddenActiveFilterCount} more`;

      // Update the active filters to only include visible elements so we have an accurate measure of the container scrollheight
      activeFilters = Array.from(activeFiltersContainer.children).filter(
        filter =>
          !filter.classList.contains("hidden") &&
          filter.classList.contains("js-active-filter")
      );
    }

    if (activeFiltersContainer.scrollHeight < maxHeight / 2) {
      showMoreButton.classList.add("hidden");
    }
  }
};

const toggleActiveFiltersExpansion = () => {
  const showMoreButton = document.querySelector(".js-show-more-button");
  const activeFiltersContainer = document.querySelector(".active-filters");
  if (activeFiltersContainer) {
    if (document.body.classList.contains("js-filters-expanded")) {
      document.body.classList.remove("js-filters-expanded");
      reflowActiveFilters();
    } else {
      document.body.classList.add("js-filters-expanded");
      document
        .querySelectorAll(".js-active-filter")
        .forEach(el => el.classList.remove("hidden"));
      showMoreButton.innerText = "Show less -";
    }
  }
};

window.addEventListener("popstate", async e => {
  // Make sure we don't re-render on initial load,
  // can be caused by navigating back from an external site
  if (e?.state?.options?.fromExternal) {
    return;
  }
  const { state } = e;
  if (state && state.attributes) {
    if (document.querySelector(".sidebar-checkbox")) {
      document
        .querySelectorAll(".category-overlay")
        .forEach(el => el.classList.add("shown"));
    }

    const baseUrl = window.location.pathname;

    const result = await api.get(`${baseUrl}?${state.attributes}`, {
      baseURL: null
    });

    destroyVueApps();

    const div = document.createElement("div");
    div.innerHTML = result.data;

    const replaceHtml = selector => {
      const currentHtml = document.querySelector(selector);
      const newHtml = div.querySelector(selector);

      if (currentHtml && newHtml) {
        currentHtml.innerHTML = newHtml.innerHTML;
      }
    };

    replaceHtml(".category-replace");
    replaceHtml(".category-sidebar-column");
    replaceHtml(".category-total-count");
    replaceHtml(".category-top-bar");
    replaceHtml(".category-title");
    replaceHtml(".active-filters-bar");
    replaceHtml(".filters .filters-top-bar");
    replaceHtml("#mobile-filters-data");
    replaceHtml("#vuwt");

    const htmlChanged = new Event("htmlChanged");
    window.dispatchEvent(htmlChanged);

    window.resetFavourites();
    initSorterResize();
    reflowActiveFilters();

    // Mobile Filters Data (to be removed)
    const mobileFiltersNode = div.querySelector("#mobile-filters-data");
    let mobileFiltersData = {};

    if (mobileFiltersNode) {
      const props = JSON.parse(mobileFiltersNode.dataset.props);
      mobileFiltersData = JSON.parse(JSON.stringify(props));

      window.dispatchEvent(
        new CustomEvent("mobileFiltersUpdated", {
          detail: mobileFiltersData.filters
        })
      );
    }

    // New filters data
    const filtersNode = div.querySelector("#filters-data");
    let filtersData = {};

    if (filtersNode) {
      const props = JSON.parse(filtersNode.dataset.props);

      filtersData = JSON.parse(JSON.stringify(props));
      window.dispatchEvent(
        new CustomEvent("filtersUpdated", {
          detail: filtersData.filters
        })
      );
      window.dispatchEvent(
        new CustomEvent("filterResultsUpdated", {
          detail: filtersData.totalCount
        })
      );
      window.dispatchEvent(new CustomEvent("clearAllFilters"));
    }
  }
});

window.addEventListener("pagehide", () => {
  // Workaround for popstate firing on initial page load when
  // navigating back from an 'external' page
  // i.e. a page that hasn't been navigated to with pushstate
  if (window.history.state) {
    const { url, as, options } = window.history.state;
    window.history.replaceState(
      { url, as, options: { ...options, fromExternal: true } },
      null,
      as
    );
  }
});

const updateFilters = (form = null) => {
  const formToUse = form || document.querySelector(".filters");
  const baseUrl = formToUse.getAttribute("action");
  const { addToPath } = formToUse.dataset;
  const formData = parse(formToUse);
  window.postMessage({ type: "incrementFilterCount" });
  applyFilters(formData, baseUrl, !!addToPath);
};

const setupListeners = () => {
  on("click", ".js-filter-cross", (el, e) => {
    e.preventDefault();
    const checkbox = document.querySelector(
      `.filters input[value="${el.dataset.value}"]`
    );
    checkbox.checked = false;
    updateFilters();
  });

  on("click", ".js-filter-cross-b", (el, e) => {
    e.preventDefault();
    const removeActiveFilter = new CustomEvent("removeActiveFilter", {
      detail: {
        filterTitle: el.dataset.filterTitle,
        optionName: el.dataset.optionName
      }
    });
    window.dispatchEvent(removeActiveFilter);
  });

  on("click", ".js-clear-filters", (el, e) => {
    e.preventDefault();
    const checkboxes = document.querySelectorAll`.filters input`;
    Array.from(checkboxes).forEach(box => {
      box.checked = false;
    });
    updateFilters();
  });

  on("click", ".top-filters-label-container", el => {
    const { filter } = el.dataset;
    analytics.track("Clicked Filter", {
      name: filter
    });
    const showFilterDrawerEvent = new CustomEvent("showFilterDrawer", {
      detail: filter
    });
    window.dispatchEvent(showFilterDrawerEvent);
  });

  on("click", ".all-filters-button-js", () => {
    analytics.track("Clicked All Filters");
    const showAllFilterDrawerEvent = new CustomEvent("showAllFilterDrawer");
    window.dispatchEvent(showAllFilterDrawerEvent);
  });

  // Due to multiple sorters present on the page we need to make sure they have the same value when one changes.

  on("change", ".js-sorter", el => {
    document.querySelectorAll(".js-sorter").forEach(sorter => {
      sorter.value = el.value;
      window.dispatchEvent(
        new CustomEvent("updateSort", { detail: sorter.value })
      );
      initSorterResize();
    });
  });

  on("change", ".filters input", () => {
    const formToParse = document.querySelector(".filters-control");
    updateFilters(formToParse);
  });

  on("click", ".js-show-more-button", toggleActiveFiltersExpansion);
};

ready(() => {
  if (document.querySelector(".filters")) {
    setupListeners();
    initSorterResize();
    reflowActiveFilters();
    window.history.replaceState(
      { attributes: serialise(parse(".filters")) },
      document.title
    );
  }
});
